/* eslint-disable @typescript-eslint/no-explicit-any */
import { FunctionComponent, useRef, useState, useCallback } from 'react'

import { colors } from 'shared/styles/colors'

import iconLoadImg from '../../assets/icons/icon-loadimg.png'
import SizedBox from '../SizedBox'
import Text from '../Text'
import { IInputFileComponentProps } from './InputFileComponent.types'
import { StyledInputFile, ButtonFile } from './styles'

const InputFile: FunctionComponent<IInputFileComponentProps> = ({
  id,
  onSelectFile,
  file,
  color,
  colorFileText,
  isWrongExtension,
}) => {
  const inputFileRef = useRef<HTMLInputElement>(null)
  const [nameFile, setNameFile] = useState(file)

  const handleChangeFile = useCallback(() => {
    if (
      inputFileRef.current?.files &&
      inputFileRef.current.files[0] &&
      inputFileRef.current.files[0].name
    ) {
      const reader = new FileReader()

      reader.onload = function (e: any) {
        onSelectFile(e.target.result, inputFileRef.current.files[0].name)
      }

      setNameFile(inputFileRef.current.files[0].name)
      reader.readAsDataURL(inputFileRef.current.files[0])
    }
  }, [onSelectFile, setNameFile])

  return (
    <>
      <StyledInputFile
        ref={inputFileRef}
        type="file"
        id={id}
        onChange={handleChangeFile}
        accept="image/png, image/jpeg, image/jpg, application/pdf"
      />
      <ButtonFile htmlFor={id} color={color}>
        <img src={iconLoadImg} alt="Carregar imagem" />
        Escolher arquivo
      </ButtonFile>
      <SizedBox />
      {nameFile && !isWrongExtension && (
        <Text
          color={colorFileText ? colors.blueLight : colors.greenLight}
          weight="bold"
          fontStyle="italic"
        >
          {nameFile}
        </Text>
      )}

      {nameFile && isWrongExtension && (
        <>
          <Text color={colors.red} weight="bold" fontStyle="italic">
            {nameFile}
          </Text>
          <Text color={colors.red} weight="bold" fontStyle="italic">
            Formato inválido, inserir arquivos: .jpg, .jpeg, .png, .pdf, .jfif
          </Text>
        </>
      )}

      {!nameFile && !isWrongExtension && (
        <Text color={colorFileText ?? colors.white}>
          Aceita arquivos: .jpg, .jpeg, .png, .pdf, .jfif
        </Text>
      )}
    </>
  )
}

export default InputFile
